<template>
  <v-app app>
    <v-app-bar app color="success darken-3" dark id="no-background">
      <router-link to="/">
        <v-img
          :src="pjImage"
          min-height="40"
          min-width="40"
          max-height="40"
          max-width="40"
          height="40"
          width="40"
        ></v-img>
      </router-link>

      <v-spacer></v-spacer>
      <v-toolbar-title app
        ><h1>{{ name }}</h1></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <administrator></administrator>
      <authentication></authentication>
    </v-app-bar>

    <appnavigation></appnavigation>
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <div v-if="isLoading()">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer color="success darken-2" padless>
      <v-row>
        <v-col class="success darken-3 py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} —
          <strong>pjmga.org</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import store from '@/store/index.js'
import appnavigation from '@/components/AppNavigation.vue'
import authentication from '@/components/Authentication.vue'
import administrator from '@/components/Administrator.vue'
import AssociationService from '@/services/api/AssociationService.js'
import router from '@/router/index.js'
import API from '@/services/api/index'

export default {
  name: 'App',

  components: {
    administrator,
    appnavigation,
    authentication
  },
  created() {
    this.getAssociation()
    console.log('Base URL:', API.BASE_URL)
  },
  store: store,
  data: () => ({
    pjImage: require('@/assets/PJ.png'),
    name: ''
  }),
  methods: {
    isLoading() {
      return this.$store.getters.getLoading
    },

    getAssociation() {
          store.commit('isLoading')
      AssociationService.get(1)
        .then(result => {
          this.name = result.name
          store.commit('setAssociation', result)
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    onHome() {
      router.push('/')
    }
  }
}
</script>
<style>
#no-background::before {
  background-color: transparent !important;
}
</style>
